export function makeStringToUtf8Bytes(text: string) {
  const byteView: any[] = [];
  if (text != null) {
    for (let i = 0; i < text.length; i++) {
      const c = text.charCodeAt(i);
      if (c <= 0x7f) {
        byteView.push(c);
      } else if (c <= 0x07ff) {
        byteView.push(((c >> 6) & 0x1f) | 0xc0);
        byteView.push((c & 0x3f) | 0x80);
      } else {
        byteView.push(((c >> 12) & 0x0f) | 0xe0);
        byteView.push(((c >> 6) & 0x3f) | 0x80);
        byteView.push((c & 0x3f) | 0x80);
      }
    }
  }

  return byteView;
}
